import AJAX from 'utils/ajax'
import { Controller } from '@hotwired/stimulus'
import { hideElement, showElement } from 'utils/toggle_element_visibility'

export default class extends Controller {
  initialize() {
    this.emailField = this.element.querySelector("input[name='user[email]']")
    this.passwordField = this.element.querySelector("input[name='user[password]']")
    // Ensure we're using the boolean field remember_me and not the hidden type generated by Formtastic
    this.rememberMeField = this.element.querySelector("input[type='checkbox'][name='user[remember_me]']")
    this.submitButton = this.element.querySelector("button[type='submit']")
    this.hasRetriedCSRF = false
  }

  async onSuccess(response) {
    const loginError = this.element.querySelector("[data-js-login-error]")
    loginError.animate({
      opacity: 0
    }, {
      duration: 50, easing: "linear", iterations: 1, fill: "both"
    })
    hideElement(loginError)

    const jsonResponse = await response.json()
    this.updateCSRFToken(jsonResponse)

    const formContinueTo = this.element.querySelector("input[name='continue_to']").value
    // The server can sometimes hold information about where to take the user,
    // eg. via Devise's stored_location_for that gives us the URL the
    // user originally tried to access.
    // The default value is the root path ("/")
    const serverContinueTo = response.headers.get("Location")

    if (formContinueTo) {
      window.location = formContinueTo
    } else if (serverContinueTo !== "/" && serverContinueTo !== undefined) {
      window.location = serverContinueTo
    } else {
      // refresh if no explicit/custom 'continue to' value given
      window.location = window.location.pathname
      if (window.location.hash) { window.location.hash = window.location.hash }
    }
  }

  onError(response) {
    // Handle migrated user error response (409 status with error)
    if (response.status === 409) {
      window.location = "/users/barbri-login"
      return
    }

    const responseBody = JSON.parse(response.body)

    hideElement(this.element.querySelector("[data-js-login-error]"))
    this.updateCSRFToken(responseBody)

    if (response.status === 422) {
      if (this.hasRetriedCSRF) {
        const errorMessage = responseBody.error || "Your session may have expired. Please refresh the page and try again."
        this.element.querySelector("[data-js-login-error-message]").innerHTML = errorMessage
        showElement(this.errorAlert)
      } else {
        // Take the new CSRF tokens from the response
        // and try just one more time.
        this.hasRetriedCSRF = true
        this.element.requestSubmit()
      }
    } else if (responseBody.error && responseBody.error.match("You have to confirm your account")) {
      window.location = "/users/unconfirmed"
    } else {
      showElement(this.element.querySelector("[data-js-login-error]"))
    }
    this.passwordField.value = ""
    this.submitButton.disabled = false
    this.emailField.focus()
  }

  updateCSRFToken(responseBody) {
    const responseCSRFToken = responseBody.csrf_token
    const responseCSRFParam = responseBody.csrf_param

    if (responseCSRFToken) {
      document.querySelector("meta[name='csrf-token']").setAttribute("content", responseCSRFToken)
    }
    if (responseCSRFParam) {
      document.querySelector("meta[name='csrf-param']").setAttribute("content", responseCSRFParam)
    }
  }

  submit(event) {
    event.preventDefault()
    const loginError = this.element.querySelector("[data-js-login-error]")

    loginError.animate({
      opacity: 0.2
    }, {
      duration: 50, easing: "linear", iterations: 1, fill: "both"
    })
    loginError.style.display = "flex"
    loginError.animate({
      opacity: 1
    }, {
      duration: 50, easing: "linear", iterations: 1, fill: "both"
    })

    const data = {
      user: {
        email: this.emailField.value,
        password: this.passwordField.value,
        remember_me: this.rememberMeField.checked
      }
    }

    AJAX.post("/users/sign_in.json", data).then((response) => {
      this.onSuccess(response)
    }).catch((error) => {
      this.onError(error.response)
    })
  }
}
